<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:13
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-05-13 15:56:09
 * @FilePath: \crm-product\found\views\cps\views\execute\details_of_counterfeit_goods\details_of_counterfeit_goods.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  name: 'modules',
  extends: TablePage,
  data() {
    return {
      requestType: 'GET',
      requestUrl: '/cps-mobile/h5/fleeingGoods/detail/findByConditions',
      params: {},
      formConfig: {},
      modalConfig: {},
      searchFormData: {},
      formData: {},
      nowDate: null,
    };
  },
  async created() {
    this.nowDate = new Date().getTime();
    this.params.listId = this.nowDate;
    await this.getConfigList('details_of_counterfeit_goods_list');
  },
  methods: {
    beforeButtonClick({ val }) {
      if (val.code === 'export') {
        val.queryUrl = `/cps-mobile/h5/fleeingGoods/detail/findByConditions?listId=${this.nowDate}`;
      }
      return true;
    },
  },
};
</script>
